// lib
import React from 'react'
import PropTypes from 'prop-types'

// components
import ControlsComponents from '@aytm/app/stats/page/question-views/oe/components/ControlsComponents'

// styles
import style from '@aytm/app/stats/page/question-views/oe/styles/Controls.module.scss'

const Controls = ({ disabled, ...props }) =>
  disabled ? null : (
    <div className={`${style.component} p-fluid`}>
      <ControlsComponents {...props} />
    </div>
  )

Controls.propTypes = {
  disabled: PropTypes.bool
}

Controls.displayName = 'Controls'

export default Controls
